const unityLanguageMap: Record<string, string> = {
  ca: 'Catalan',
  en: 'English',
  en_US: 'EnglishUS',
  eu: 'Basque',
  va: 'Valencian',
  it_IT: 'Italian',
  pt_BR: 'Portuguese',
};

export const getUnityLanguage = (language: string) => {
  if (language.startsWith('es_')) {
    return 'SpanishMX';
  }

  return unityLanguageMap[language] ?? 'Spanish';
};
